import { FC } from "react";
import { CustomButton } from "../button/button";
import { getAccentColor } from "../../../util/common-functions";
import { Colors } from "../../../configs";
import { pxToRem } from "../../../util";
import { SxProps } from "@mui/material";
import { Theme } from "@emotion/react";

export interface IPinTagButtonProps {
  color: string;
  code: string;
  onClick: () => void;
  isSelected?: boolean;
  disabled?: boolean;
  isPintagModalButton?: boolean;
  sx?: SxProps<Theme>;
}

export const PinTagButton: FC<IPinTagButtonProps> = ({
  color,
  code,
  onClick,
  isSelected = false,
  disabled = false,
  isPintagModalButton = false,
  sx = {},
}) => {
  return (
    <CustomButton
      sx={{
        background: color,
        color: disabled ? Colors.ACCENT_GRAY : getAccentColor(color),
        width: isPintagModalButton
          ? { xs: pxToRem(48), sm: pxToRem(49.8) }
          : { xs: pxToRem(34), sm: pxToRem(36.39) },
        height: { xs: pxToRem(34), sm: pxToRem(36.39) },
        maxWidth: isPintagModalButton
          ? { xs: pxToRem(48), sm: pxToRem(49.8) }
          : { xs: pxToRem(34), sm: pxToRem(36.39) },
        maxHeight: { xs: pxToRem(34), sm: pxToRem(36.39) },
        minWidth: isPintagModalButton
          ? { xs: pxToRem(48), sm: pxToRem(49.8) }
          : { xs: pxToRem(34), sm: pxToRem(36.39) },
        minHeight: { xs: pxToRem(34), sm: pxToRem(36.39) },
        border: isSelected
          ? `${pxToRem(3)} solid ${Colors.SECONDARY}`
          : disabled && !isPintagModalButton
            ? `${pxToRem(1)} dashed ${Colors.ACCENT_GRAY_DISABLED}`
            : "none",
        boxShadow: isSelected
          ? `0 0 0 ${pxToRem(2)} white inset, 0 0 0 ${pxToRem(1)} ${Colors.SECONDARY}, 0 ${pxToRem(4)} ${pxToRem(12)} rgba(0,0,0,0.25)`
          : "none",
        transform: isSelected ? "scale(1.15)" : "scale(1)",
        transition: "transform 0.15s ease, box-shadow 0.15s ease",
        zIndex: isSelected ? 1 : 0,
        fontWeight: "bold",
        padding: "0 !important",
        ...sx,
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {/* {disabled && isPintagModalButton ? "" : code} */}
      {code == "N/A" ? "" : code}
    </CustomButton>
  );
};
